import * as pbi from '../public/index.component';
declare var $: any;
@pbi.Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: [
    '../../assets/pages/css/login-5.min.css',
    'login.component.css'
  ]
})
export class LoginComponent {
  showLoad: boolean = true;
  backLoad: string = "#FFF";
  user: string = "";
  pass: string = "";
  email: string = "";
  remember: boolean = false;
  pb_func: pbi.PublicComponent = new pbi.PublicComponent();
  constructor(private router: pbi.Router) {
    let user = localStorage.getItem("user");
    if (user != null) {
      let arr_user = user.split('(##)');
      this.user = arr_user[0];
      this.pass = arr_user[1];
      this.remember = true;
    }
  }
  ngOnInit() {
    var this_sav = this;
    this_sav.pb_func.loadScript([
      'assets/global/plugins/jquery-validation/js/jquery.validate.min.js',
      'assets/global/plugins/jquery-validation/js/additional-methods.min.js',
      'assets/global/plugins/backstretch/jquery.backstretch.min.js',
      'assets/pages/scripts/login-5.js',
      'assets/global/plugins/js.cookie.min.js',
      'assets/global/plugins/bootstrap-hover-dropdown/bootstrap-hover-dropdown.min.js',
      'assets/global/plugins/jquery-slimscroll/jquery.slimscroll.min.js',
      'assets/global/plugins/jquery.blockui.min.js',
      'assets/global/plugins/uniform/jquery.uniform.min.js',
      'assets/global/plugins/bootstrap-switch/js/bootstrap-switch.min.js',
      'assets/global/scripts/app.min.js'
    ], 'login', function () {
      setTimeout(() => {
        this_sav.showLoad = false;
      }, 1000);
    });
  };

  SignIn() {
    var this_sav = this;
    var data = { user: this_sav.user, pass: this_sav.pass };

    var loginfrm = $('.login-form');

    if (loginfrm.validate().form()) {
      this_sav.showLoad = true;
      this_sav.backLoad = "#352e2e87";

      this_sav.pb_func.callAPI('api/User/login', 'POST', data, null, function (status, mess) {
        this_sav.showLoad = false;
        this_sav.backLoad = "#FFF";
        if (status == 1) {
          if (this_sav.remember) {
            window.localStorage.setItem("user", this_sav.user + "(##)" + this_sav.pass);
          }
          else {
            window.localStorage.removeItem("user");
          }
          this_sav.pb_func.setToken(mess);
          this_sav.router.navigate(['/admin/dashboard']);
        }
        else {
          $.notify(mess, { globalPosition: 'top right', className: 'error' });
        }
      });
    }
  }

  ForgotPassword() {
    var this_sav = this;
    var data = { user: this_sav.user, email: this_sav.email };
    var forgetfrm = $('.forget-form');

    if (forgetfrm.validateEmail()) {
      this_sav.showLoad = true;
      this_sav.backLoad = "#352e2e87";
      this_sav.pb_func.callAPI('api/User/ForgetPass', 'POST', data, null, function (status, mess) {
        this_sav.showLoad = false;
        this_sav.backLoad = "#FFF";
        if (status == 1) {
          $('#back-btn').click();
          $.notify(mess, { globalPosition: 'top right', className: 'success' });
        }
        else {
          $.notify(mess, { globalPosition: 'top right', className: 'error' });
        }
      });
    }
  }

  RememberPass() {
    if (this.remember == false) {
      window.localStorage.removeItem("user");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts